export default __webpack_public_path__ + "static/media/2501251.e7cf3ffc.jpg";